import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {HttpClient} from '@angular/common/http';
import {tap} from 'rxjs/operators';
import {BackendService} from '../../services/backend.service';
import {BekocheckAnfrage} from '../anfrage/bekocheck.anfrage';
import {DebugService} from '../../debug/debug.service';

/**
 * Service for dealing with the backend and make request to the backend.
 */
@Injectable({
  providedIn: 'root'
})
export class BekocheckBackendService extends BackendService {

  /**
   * @inheritDoc
   */
  requestIdName = 'bkc-requestid';

  /**
   * @inheritdoc
   */
  backendDataEndpoint = '/bkc/data/';

  /**
   * constructor.
   * @param http
   * @param backendService
   * @param debugService
   */
  constructor(protected http: HttpClient, private backendService: BackendService, protected debugService: DebugService) {
    super(http, debugService);
  }

  /**
   * @inheritDoc
   * this is a small workaround so other components can still access the generic backendservice and will get the real advisor name
   * @param advisor
   */
  setAdvisor(advisor: string) {
    super.setAdvisor(advisor);

    this.backendService.setAdvisor(advisor);
  }

  /**
   * Sends the users input to the API
   */
  sendDataToApi(anfrage: BekocheckAnfrage): void {
    this.getRequestId().subscribe(requestId => {
      this.http.post('/bkc/send_data_to_api/' + requestId, anfrage).subscribe(result => {
        console.log(result);
      }, error => {
        console.error('an error occurred while sending the data to bks api');
        console.log(error);
      });
    });
  }

  /**
   * starts the calculation
   * @param anfrage
   * @param requestId
   */
  result(anfrage: BekocheckAnfrage, requestId: string): Observable<any> {
    return this.http.post('/bkc/result/' + requestId, anfrage).pipe(
      tap(data => {
        if (data.debug) {
          this.addDebug(data.debug);
        }
      })
    );
  }

}
